import { c as _c } from "react/compiler-runtime";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { getThemeColors } from "./ParticipationDropRatingsTheme";
import type { RatingsData } from "./types";
import ParticipationDropRatingsTotalSection from "./ParticipationDropRatingsTotalSection";
import ParticipationDropRatingsVoterSection from "./ParticipationDropRatingsVoterSection";
import ParticipationDropRatingsUserSection from "./ParticipationDropRatingsUserSection";
interface ParticipationDropRatingsContainerProps {
  readonly drop: ApiDrop;
  readonly rank?: number | null | undefined;
  readonly winningThreshold?: number | null | undefined;
  readonly winningThresholdMinDurationMs?: number | null | undefined;
  readonly isVotingClosed?: boolean | undefined;
}
export default function ParticipationDropRatingsContainer(t0) {
  const $ = _c(31);
  const {
    drop,
    rank: t1,
    winningThreshold,
    winningThresholdMinDurationMs,
    isVotingClosed: t2
  } = t0;
  const rank = t1 === undefined ? null : t1;
  const isVotingClosed = t2 === undefined ? false : t2;
  const t3 = drop.top_raters.length > 0;
  const t4 = drop.context_profile_context?.rating ?? 0;
  let t5;
  if ($[0] !== drop.rating || $[1] !== t3 || $[2] !== t4) {
    t5 = {
      hasRaters: t3,
      userRating: t4,
      currentRating: drop.rating
    };
    $[0] = drop.rating;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const ratingsData = t5;
  const t6 = ratingsData.currentRating < 0;
  let t7;
  if ($[4] !== rank || $[5] !== t6) {
    t7 = getThemeColors(rank, t6);
    $[4] = rank;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const theme = t7;
  let t8;
  if ($[7] !== drop || $[8] !== isVotingClosed || $[9] !== rank || $[10] !== ratingsData || $[11] !== theme || $[12] !== winningThreshold || $[13] !== winningThresholdMinDurationMs) {
    t8 = <ParticipationDropRatingsTotalSection drop={drop} rank={rank} theme={theme} ratingsData={ratingsData} winningThreshold={winningThreshold} winningThresholdMinDurationMs={winningThresholdMinDurationMs} isVotingClosed={isVotingClosed} />;
    $[7] = drop;
    $[8] = isVotingClosed;
    $[9] = rank;
    $[10] = ratingsData;
    $[11] = theme;
    $[12] = winningThreshold;
    $[13] = winningThresholdMinDurationMs;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== drop || $[16] !== rank || $[17] !== ratingsData || $[18] !== theme) {
    t9 = <ParticipationDropRatingsVoterSection drop={drop} rank={rank} theme={theme} ratingsData={ratingsData} />;
    $[15] = drop;
    $[16] = rank;
    $[17] = ratingsData;
    $[18] = theme;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t8 || $[21] !== t9) {
    t10 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-2">{t8}{t9}</div>;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== drop || $[24] !== rank || $[25] !== ratingsData || $[26] !== theme) {
    t11 = <ParticipationDropRatingsUserSection drop={drop} rank={rank} theme={theme} ratingsData={ratingsData} />;
    $[23] = drop;
    $[24] = rank;
    $[25] = ratingsData;
    $[26] = theme;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t10 || $[29] !== t11) {
    t12 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-2">{t10}{t11}</div>;
    $[28] = t10;
    $[29] = t11;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
}